import { Route, Routes } from '@angular/router';
import { dienstleistungResolver } from './dienstleistung.resolver';
import { mgsAuthenticatedGuard } from '../mgs-guards';
import { DIENSTLEISTUNG_PATH } from '../mgs-path-defs';
import { MngDeactivationGuard } from '@mng/mng-auth';
import { AttributGruppeResolver } from '../attribute/attribut-gruppe/attribut-gruppe.resolver';

const routeChildren: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./dienstleistung-uebersicht/dienstleistung-uebersicht.component').then(
        (m) => m.DienstleistungUebersichtComponent
      )
  },
  { path: 'kunde', loadComponent: () => import('../kunde/kunde/kunde.component').then((m) => m.KundeComponent) },
  {
    path: 'gruppe/:gruppe',

    loadComponent: () => import('../attribute/attribut-gruppen/attribut-gruppen.component'),
    resolve: { grupppe: AttributGruppeResolver }
  }
];

export const dienstleistungRoute: Route = {
  path: DIENSTLEISTUNG_PATH + '/:code',
  title: 'Dienstleistung',
  loadComponent: () => import('./dienstleistung.component'),
  resolve: { dienstleistung: dienstleistungResolver },
  canActivate: [mgsAuthenticatedGuard],
  canDeactivate: [MngDeactivationGuard],
  children: routeChildren
};
